module.exports = __webpack_public_path__ + "img/appEQ-squareLogo-new.cc5b93eb.png";